import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.sessionStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    slugName: "บริษัท",
    title: "บริษัท",
    description: " คำอธิบายบริษัท",
    logo: "",
    appLogo: "",
    coverImg: "",
    permission: {},
    headerColor: "#99FF66",
    buttonColor: "#CC33CC",
    footerColor: "#99FF66",
    themeColor: "#99FF66",
    age: "",
    gender: "",
    username: "",
    email: "",
    tel: "",
    displayName: "",
    image: "",
    company: {},
    firstName: "",
    lastName: "",
    school: "",
    isTeacher:"",
    info: "",
    _id:"",
    note:"",
    requestData:"",
    totalRequest:0,
  },
  mutations: {
    setTheme(state, info) {
      state.slugName = info.companies[0].slugName,
      state.title = info.companies[0].title,
      state.description = info.companies[0].description,
      state.logo = info.companies[0].logo,
      state.appLogo = info.companies[0].appLogo,
      state.coverImg = info.companies[0].coverImg,
      state.headerColor = info.companies[0].headerColor,
      state.buttonColor = info.companies[0].buttonColor,
      state.footerColor = info.companies[0].footerColor,
      state.themeColor = info.companies[0].themeColor,
      state.permission = info.permission, // superAdmin === true
      state.age = info.age,
      state.gender = info.gender,
      state.email = info.email,
      state.username = info.username,
      state.tel = info.tel,
      state.displayName = info.displayName,
      state.image = info.image,
      state.company = info.companies[0],
      state.image = info.image,
      state.firstName = info.firstName,
      state.lastName = info.lastName,
      state.school = info.school ? info.school : '',
      state.isTeacher = info.isTeacher ,
      state._id= info._id
      state.note= info.verifyTeacher ? info.verifyTeacher.note: ''
    },
    setTotal(state, total) {
      state.requestData = total;

      let sum = 0;
      total.forEach(request => {
        sum += request.totalLearner
      });
      state.totalRequest = sum
    },
    clear(state, val = null) {
      state = val
    }
  },
  actions: {},
  modules: {},
  getters: {
    title: (state) => {
      return state.title
    },
    description: (state) => {
      return state.description
    },
    logo: (state) => {
      return state.logo
    },
    appLogo: (state) => {
      return state.appLogo
    },
    coverImg: (state) => {
      return state.coverImg
    },
    headerColor: (state) => {
      return state.headerColor
    },
    buttonColor: (state) => {
      return state.buttonColor
    },
    footerColor: (state) => {
      return state.footerColor
    },
    themeColor: (state) => {
      return state.themeColor
    },
  },
  plugins: [vuexLocalStorage.plugin]
})